// # Asset preloader utility
const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

const preloadAudio = (src) => {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.oncanplaythrough = () => resolve(audio);
    audio.onerror = reject;
    audio.src = src;
  });
};

export const preloadWelcomeAssets = async () => {
  try {
    const assets = await Promise.all([
      preloadImage('/icons/signup/logo512.png'),
      preloadAudio('/aneo_media/sounds/cinematic_piano.mp3')
    ]);
    
    // # Store preloaded assets in sessionStorage
    sessionStorage.setItem('welcomeAssetsPreloaded', 'true');
    console.log('Welcome assets preloaded successfully');
    return assets;
  } catch (error) {
    console.warn('Failed to preload some welcome assets:', error);
    return null;
  }
}; 